import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { IMAGE_BLOCK_FEATURE_KEY } from './keys';
import { imageBlockReducer } from './reducers/image-block.reducer';
import { ImageBlockEffects } from './effects/image-block.effects';

export const imageBlockStoreProviders = [provideState(IMAGE_BLOCK_FEATURE_KEY, imageBlockReducer), provideEffects(ImageBlockEffects)];

export { ImageBlockFacade } from './facades/image-block.facade';
export { ImageBlock } from './models';
